import React, { createContext, useState } from "react";
import { jwtDecode } from "jwt-decode"

import { roles, updateRoles as updateGlobalRoles } from "./Constants"; 
// (adjust path if needed)

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [authState, setAuthState] = useState({
    username: "",
    email: "",
    cq: "",
    ooc: "",
    retpack: "",
    isAuthenticate: false,
  });
  const logout = () => {
    localStorage.clear();

    setAuthState({
      username: "",
      email: "",
      cq: "",
      ooc: "",
      retpack: "",
      isAuthenticate: false,
    });

    // reset global roles also
    updateGlobalRoles({
      roleToken: null,
      roleTokenPayload: {},
      role: "",
      ooc_user_role: "",
      userRole: ""
    });
  };

  //login username/email
  const login = (data) => {
    setAuthState(prev => ({
      ...prev,
      username: data.username,
      email: data.email,
      cq: data.cq || prev.cq,
      ooc: data.ooc || prev.ooc,
      retpack: data.retpack || prev.retpack,
      isAuthenticate: true,
    }));
  };

  //roles updated after calling roletoken
  const updateRoles = (roleToken) => {
    try {
      const decoded = jwtDecode(roleToken);

      const { roles: tokenRoles, email, iat, exp } = decoded;

      // Update React auth state
      setAuthState(prev => ({
        ...prev,
        cq: tokenRoles?.cq || "",
        ooc: tokenRoles?.ooc || "",
        retpack: tokenRoles?.retpak || "",
      }));

      updateGlobalRoles({
        roleToken,
        roleTokenPayload: {
          cq: tokenRoles?.cq || "",
          ooc: tokenRoles?.ooc || "",
          retpak: tokenRoles?.retpak || "",
          email: email,
          iat,
          exp
        },

        //for backward compatibility with old system
        role: tokenRoles?.cq || "",
        ooc_user_role: tokenRoles?.ooc || "",
        userRole: tokenRoles?.retpak || ""
      });

    } catch (err) {
      console.error("Invalid role token:", err);
    }
  };

  return (
    <AuthContext.Provider 
      value={{ 
        authState, 
        setAuthState, 
        login, 
        logout,
        updateRoles 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
